export default function LoginLogoComponent() {
  return (
    // next/Imageが使えないので、一旦imgタグで対応
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src="/images/login-logo.png"
      alt="logo"
      loading="lazy"
      width={200}
      height={200}
    />
  )
}
